<template>
	<div>
		<el-dialog
			title="更新规划进度"
			:visible.sync="dialogVisible"
			width="25%"
			top="10vh"
			:close-on-click-modal="false"
			:before-close="handleClose"
			custom-class="plan-dialog">
			<div class="info">
				<div>规划编号：{{ data.planNo }}</div>
				<div>资产名称：{{ data.assetName }}</div>
				<div>当前进度：{{ data.progress }}%</div>
			</div>
			<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="当前进度(%)" prop="progress">
							<el-input
								type="number"
								v-model.number="form.progress"
								size="small"
								placeholder="请填写当前进度"
								class="no-spinner" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="进度说明" prop="progressDescription">
							<el-input type="textarea" v-model="form.progressDescription" size="small" placeholder="请填写进度说明" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="上传凭证" prop="attachments">
							<FileUpload
								ref="upload"
								:limit="1"
								:accept="['jpg', 'png', 'jpeg', 'pdf']"
								v-model="fileList"
								@success="handleUploadSuccess"
								title="上传进度凭证">
								<template slot="tip">如租赁合同、改造现场照片等</template>
							</FileUpload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!-- 按钮 -->
			<span slot="footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="handleSubmit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { getAssetPlanProgressSave } from '@/api/asset/assetPlanApi.js';
	export default {
		name: 'AssetPlanProgressDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				fileList: [],
				form: {
					planId: '',
					operator: JSON.parse(localStorage.getItem('user') || '{}').name || '',
					progress: '',
					progressDescription: '',
					attachments: '',
				},
				rules: {
					progress: [
						{
							required: true,
							message: '请输入当前进度',
							trigger: 'blur',
						},
						{
							validator: (rule, value, callback) => {
								const num = Number(value);
								const minValue = Number(this.data.progress);
								if (isNaN(num)) {
									callback(new Error('请输入数字'));
								} else if (num < 0 || num > 100) {
									callback(new Error('进度必须在0-100之间'));
								} else if (num < minValue) {
									callback(new Error(`进度不能小于${minValue}`));
								} else {
									callback();
								}
							},
							trigger: 'blur',
						},
					],
					progressDescription: [{ required: true, message: '请输入进度说明', trigger: 'blur' }],
				},
			};
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						console.log(this.data, 'data');
						this.$refs.form.resetFields();
						this.form.planId = this.data.id;
					});
				} else {
					this.$refs.upload.reset();
				}
			},
		},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			resetForm() {
				this.$nextTick(() => {
					this.$refs.form && this.$refs.form.resetFields();
				});
			},
			handleUploadSuccess(res, fileList) {
				this.form.attachments = fileList.map(item => item.response).join(',');
			},
			handleSubmit() {
				this.$refs.form.validate(async valid => {
					if (!valid) return;
					try {
						await getAssetPlanProgressSave(this.form);
						this.$message.success('编辑成功');
						this.$emit('updateSuccess');
						this.handleClose();
					} catch {
						this.$message.error('编辑失败');
					}
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.plan-dialog) {
		.no-spinner .el-input__inner::-webkit-outer-spin-button,
		.no-spinner .el-input__inner::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		.no-spinner .el-input__inner[type='number'] {
			-moz-appearance: textfield; /* Firefox */
		}

		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #c1c1c1;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}

	.info {
		color: #1c1c1c;
		font-size: 15px;
		display: flex;
		flex-direction: column;
		gap: 10px;
		margin-bottom: 10px;
	}
</style>
